import React, { useEffect, useState } from 'react';
import { Button as ButtonUi } from '@material-ui/core';

import useBreakpoint, { useIsBreakpoint } from '../../../hooks/breakpoint';
import classes from './Button.module.scss';

const Button = ({
  children,
  mobileSize,
  mediumSize,
  largeSize,
  cardButton,
  hide,
  type,
  id,
  className,
  color,
  tag,
  onClick,
  ...props
}) => {
  const { variant, size } = props;
  const [isBreakpoint, setIsBreakpoint] = useIsBreakpoint();
  const { mobile, medium, large } = useBreakpoint();
  const [hiddenClasses, setHiddenClasses] = useState([]);
  const buttonClasses = [classes.Button];

  useEffect(() => {
    setIsBreakpoint(hide);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hide]);

  useEffect(() => {
    if (hide && isBreakpoint) {
      setHiddenClasses([classes.hidden]);
    } else {
      setHiddenClasses([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBreakpoint]);

  const handleButtonClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  if (mobile) {
    if (mobileSize) {
      buttonClasses.push(classes[mobileSize]);
    } else {
      buttonClasses.push(classes.large);
    }
  } else if (medium) {
    if (mediumSize) {
      buttonClasses.push(classes[mediumSize]);
    } else {
      buttonClasses.push(classes.medium);
    }
  } else if (large) {
    if (largeSize) {
      buttonClasses.push(classes[largeSize]);
    } else {
      buttonClasses.push(classes.medium);
    }
  }

  if (typeof variant === 'string') {
    buttonClasses.push(classes[variant]);
  }
  if (typeof size === 'string') {
    buttonClasses.push(classes[size]);
  }
  if (typeof color === 'string') {
    buttonClasses.push(classes[color]);
  }
  if (cardButton) {
    buttonClasses.push(classes.card);
  }
  if (className) {
    buttonClasses.push(className);
  }

  return (
    <ButtonUi
      className={buttonClasses.concat(hiddenClasses).join(' ')}
      id={id || 'button'}
      type={type || 'button'}
      onClick={(e) => handleButtonClick(e)}
      {...props}
    >
      {children}
    </ButtonUi>
  );
};

export default Button;
